import { Company, Project } from "../../../../types/Company";
import { ProjectsAvailableSessionTypes } from "../../../../types/Projects";
import { getTranslation } from "../../../../utils/getTranslation";
import { formatDateForProjectInput } from "../projectFormModel";
import s from "../ProjectFormPage.module.css";
import {
  ProjectFormController,
  ProjectFormMode,
} from "../useProjectFormController";

type ReviewStepProps = {
  company: Company;
  controller: ProjectFormController;
  mode: ProjectFormMode;
  project: Project | null;
};

const projectTypeLabels: Record<ProjectsAvailableSessionTypes, string> = {
  [ProjectsAvailableSessionTypes.SESSION]: "Sessions",
  [ProjectsAvailableSessionTypes.PACKAGE]: "Packages",
  [ProjectsAvailableSessionTypes.REAL_TIME_SESSION]: "Real-time sessions",
};

const formatBoolean = (value?: boolean) => (value ? "Yes" : "No");

const ReviewItem = ({ label, value }: { label: string; value: string }) => (
  <div className={s.reviewItem}>
    <span className={s.label}>{label}</span>
    <span className={s.value}>{value}</span>
  </div>
);

const ReviewStep = ({
  company,
  controller,
  mode,
  project,
}: ReviewStepProps) => {
  const title = getTranslation(controller.projectData.title, "en");
  const selectedSpecializations = controller.mainSpecializations
    .filter((item) => controller.selectedSpecializationIds.includes(item.value))
    .map((item) => item.lable);
  const projectTypes = controller.selectedProjectTypes.map(
    (type) => projectTypeLabels[type],
  );

  return (
    <div className={s.stepPanel}>
      <div className={s.section}>
        <h2 className={s.sectionTitle}>Review & Save</h2>
        <p className={s.sectionText}>
          Review the core Project settings, then save when everything is ready.
        </p>
      </div>

      <div className={s.reviewGrid}>
        <ReviewItem label="Mode" value={mode === "edit" ? "Edit" : "Create"} />
        <ReviewItem label="Company" value={company.name} />
        <ReviewItem
          label="Project"
          value={title || getTranslation(project?.title, "en") || "Untitled Project"}
        />
        <ReviewItem
          label="Project type"
          value={projectTypes.length ? projectTypes.join(", ") : "Not selected"}
        />
        <ReviewItem
          label="Specializations"
          value={
            selectedSpecializations.length
              ? selectedSpecializations.join(", ")
              : "All available specializations"
          }
        />
        <ReviewItem
          label="Client limit"
          value={controller.projectData.clientLimit.toString()}
        />
        <ReviewItem
          label="Specialist limit"
          value={controller.projectData.specialistLimit.toString()}
        />
        <ReviewItem
          label="End date"
          value={
            controller.projectData.endDate
              ? formatDateForProjectInput(controller.projectData.endDate)
              : "Not set"
          }
        />
        <ReviewItem
          label="Private Project"
          value={formatBoolean(controller.projectData.isPrivate)}
        />
        <ReviewItem
          label="Public free Project"
          value={formatBoolean(controller.projectData.isPublicAccess)}
        />
        <ReviewItem
          label="Barter"
          value={formatBoolean(controller.projectData.isBarter)}
        />
      </div>
    </div>
  );
};

export default ReviewStep;
